import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import Popup from "../../../../components/Popup";
import Headline from "../../../../components/Typography/Headline";
import {
    ACTIONS,
    ITEM_TYPE,
    ProductsDetailsContext,
} from "../../ProductsProvider";
import { X, Check } from "react-feather";
import { SkeletonDressings } from "../../../../components/Loaders/SkeletonLoader";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import i18n from "~/assets/js/Helpers/i18n";
import { useIngredientsStock } from "../../../../Api/ingredientsApi";
import { DeliveryContext } from "../../../../models/DeliveryContext";
import CategoryItems from "../../../../components/CategoryItems";

const DressingPopup = ({ open, handleClose }) => {
    const { storeId } = useContext(DeliveryContext);
    const { isSauceProduct } = useContext(ProductsDetailsContext);

    const { dressings, sauces, isLoading } = useIngredientsStock(storeId);
    const { isDesktop } = useViewport();
    const popupConfig = {
        open: open,
        customStyle: "dressing-popup",
        draggable: true,
        handleClose: handleClose,
    };

    return (
        <Popup {...popupConfig}>
            <div style={{ position: "relative" }}>
                {isDesktop && (
                    <X size={36} className="close-icon" onClick={handleClose} />
                )}
                <Headline size={6} className="title">
                    {isSauceProduct
                        ? i18n.t("sauces.chooseSauce")
                        : i18n.t("dressings.chooseDressing")}
                </Headline>
                {isLoading ? (
                    <SkeletonDressings />
                ) : (
                    <div>
                        {(isSauceProduct ? sauces : dressings).map((item) => (
                            <DressingListItem
                                key={item.product_id}
                                dressing={item}
                                handleClose={handleClose}
                            />
                        ))}
                    </div>
                )}
            </div>
            <div className="bottom-close">
                <span onClick={handleClose}>{i18n.t("popup.close")}</span>
            </div>
        </Popup>
    );
};

const DressingListItem = ({ dressing, handleClose }) => {
    const { state, updateProductState } = useContext(ProductsDetailsContext);
    const [isDressingSelected, setIsSelected] = useState(false);

    useEffect(() => {
        let selectedDressings = [];
        if (state.dressings.length > 0) {
            selectedDressings = state.dressings.map(
                (dressing) => dressing.product_id
            );
        }
        setIsSelected(selectedDressings.includes(dressing.product_id));
    }, [state]);

    const pickDressing = () => {
        if (!isDressingSelected) {
            return addDressing();
        }
        return removeDressing();
    };

    const addDressing = () => {
        const data = {
            product_id: dressing.product_id,
            quantity: 1,
            price: dressing.price,
            local_prices: dressing.local_prices,
            name: dressing.name,
            image: dressing.images.normal,
            details: dressing.details,
        };
        updateProductState({ type: ACTIONS.ADD_DRESSING, payload: data });
        return handleClose();
    };

    const removeDressing = () => {
        const data = {
            product_id: dressing.product_id,
            itemType: ITEM_TYPE.DRESSINGS,
        };
        updateProductState({ type: ACTIONS.REMOVE, payload: data });
    };

    return (
        <div
            className={`dressing-list-item ${
                isDressingSelected ? "selected" : ""
            }`}
            onClick={pickDressing}
        >
            <div className="dressing-list-item__content">
                <img
                    src={dressing.images.normal}
                    alt={dressing.name}
                    width="36"
                    height="36"
                />

                <span className="name">{dressing.name}</span>
            </div>
            {!isDressingSelected && <CategoryItems tags={dressing.tags} />}

            <Check size={36} className="selected-icon" />
        </div>
    );
};

DressingListItem.propTypes = {
    dressing: PropTypes.object, // big product object
    handleClose: PropTypes.func,
};

DressingPopup.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
};

export default DressingPopup;
